/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'traffic-clone-profile';

export const trafficCloneProfileModalBreadcrumbTitle = `${prefix}.trafficCloneProfileModalBreadcrumbTitle`;
export const cloneServerModalBreadcrumbTitle = `${prefix}.cloneServerModalBreadcrumbTitle`;

export const ENGLISH = {
    [trafficCloneProfileModalBreadcrumbTitle]: 'Traffic Clone Profile',
    [cloneServerModalBreadcrumbTitle]: 'Clone Server',
};
